export default "__VITE_ASSET__g27qp25Z__"